import Debug from 'debug'
const debug = Debug('jotta:utils:copyToClipboard')

export async function copyToClipboard(value: string, forceExecCommand = false) {
  if (navigator.clipboard && !forceExecCommand) {
    debug('Copy using Clipboard api: %s', value)
    try {
      const res = await navigator.clipboard.writeText(value)
      debug('Result', res)

      return
    } catch (err) {
      debug('Error', err)
    }
  }
}
